import * as THREE from 'three'
import Experience from './Experience.js'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
export default class Camera {
    constructor() {
        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas

        this.setInstance()
        this.setControls()
    }

    setInstance() {
        console.log(this.canvas);
        this.instance = new THREE.PerspectiveCamera(35, this.sizes.width / this.sizes.height, 0.01, 1000)
        this.instance.position.set(0,8,0)
        this.scene.add(this.instance)

        

    }

    setControls() {

        this.controls = new OrbitControls(this.instance, this.canvas)

        this.resources = this.experience.resources;
        console.log(this.resources);

        // this.controls.target.set(this.center.x,this.center.y,this.center.z)



       


    }
    defineControls(rotateSpeed,enableDamp,enableZoom,dampFactor,smoothZoom,enablePan,enableRotate){
        this.controls.enableRotate = enableRotate
        this.controls.enableDamping = enableDamp
        this.controls.rotateSpeed = rotateSpeed;
        this.controls.enableZoom = enableZoom;
        this.dampingFactor = dampFactor;
        this.controls.smoothZoom = smoothZoom
        this.controls.enablePan=enablePan
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

        if (isMobile) {
            this.controls.enableDamping = false
            this.controls.update()

        } else {
           this.controls.enableDamping = true
           this.controls.update()

        }

    }

    resize() {
        this.instance.aspect = this.sizes.width / this.sizes.height
        this.instance.updateProjectionMatrix()
    }

    update() {

        this.controls.update()

    }
}
